<template>
  <Transition name="toast">
    <div
      v-if="uiStore.toast.show"
      class="fixed top-4 left-4 right-4 z-50 mx-auto max-w-md px-4 py-3 rounded-2xl shadow-card-lg flex items-center gap-3 border"
      :class="toastClasses"
      role="status"
      aria-live="polite"
    >
      <div class="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0" :class="iconClasses">
        <svg
          v-if="uiStore.toast.type === 'success'"
          class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
        </svg>
        <svg
          v-else-if="uiStore.toast.type === 'error'"
          class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
        <svg
          v-else-if="uiStore.toast.type === 'warning'"
          class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <svg
          v-else
          class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>

      <p class="flex-1 text-sm font-semibold text-ink">{{ uiStore.toast.message }}</p>

      <button
        @click="uiStore.hideToast()"
        class="flex-shrink-0 w-8 h-8 rounded-lg text-ink-muted hover:text-ink hover:bg-canvas-2 flex items-center justify-center transition-colors"
        aria-label="Dismiss"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useUIStore } from '@/stores/ui'

const uiStore = useUIStore()

const toastClasses = computed(() => {
  switch (uiStore.toast.type) {
    case 'success': return 'bg-surface border-success/30'
    case 'error':   return 'bg-surface border-danger/30'
    case 'warning': return 'bg-surface border-warn/30'
    default:        return 'bg-surface border-line'
  }
})

const iconClasses = computed(() => {
  switch (uiStore.toast.type) {
    case 'success': return 'bg-success-soft text-success'
    case 'error':   return 'bg-danger-soft text-danger'
    case 'warning': return 'bg-warn-soft text-warn'
    default:        return 'bg-canvas-2 text-ink'
  }
})
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.28s cubic-bezier(0.22, 1, 0.36, 1);
}
.toast-enter-from {
  opacity: 0;
  transform: translateY(-18px) scale(0.98);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}
</style>
